













import Vue from 'vue';
import Horizontal from '@aergoenterprise/lib-components/src/layout/Horizontal.vue';
import ViewContentWrap from './ViewContentWrap.vue';
import ViewSidebar from './ViewSidebar.vue';

export default Vue.extend({
  name: 'ViewWithSidebar',
  components: {
    Horizontal,
    ViewContentWrap,
    ViewSidebar,
  },
  props: {
    isSidebarOpen: {
      type: Boolean,
      default: true,
    },
  },
});
